export const UMB_DUPLICATE_MEMBER_TYPE_REPOSITORY_ALIAS = 'Umb.Repository.MemberType.Duplicate';
